import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import {selectUserGroup, selectUser} from '../../redux/slices/user';
import {logOut} from '../../redux/slices/auth';
import {faUser, faInfoCircle, faShieldBlank} from '@fortawesome/pro-light-svg-icons';
import {FEATURES} from '../../constants';

import styles from '../css/ProfileMenuDrawer.module.css';
import {BluePillButton} from '../../common/components/BluePillButton';

export default function ProfileMenuDrawer({isMenuOpen, toggleMenu}) {
  const history = useHistory();
  const dispatch = useDispatch();

  const userGroup = useSelector(selectUserGroup);
  const user = useSelector(selectUser);
  const {
    tier: {features},
  } = userGroup;
  const isContentProducerGroup = features.includes(FEATURES.VISIBILITY_PUBLIC);
  const userGroupType = isContentProducerGroup ? 'Producer Group' : 'Educator Group';

  function handleSecurityClick(type) {
    toggleMenu(false);
    history.push('/builder/change-password');
  }

  function handleProfessionalInformationClick(type) {
    toggleMenu(false);
    history.push('/builder/professional-info');
  }

  return (
    <Drawer anchor="right" open={isMenuOpen} onClose={() => toggleMenu(false)}>
      <ListItem>
        <ListItemIcon>
          <Avatar src={user?.avatarURL}>
            <FontAwesomeIcon icon={faUser} />
          </Avatar>
        </ListItemIcon>
        <ListItemText primary={user?.firstName} secondary={user?.lastName} />
      </ListItem>
      <Divider />

      <List className={styles['menu-list']}>
        <ListItem button onClick={() => history.push('/builder/profile')}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faUser} />
          </ListItemIcon>
          <ListItemText primary="Profile" />
        </ListItem>
        <ListItem button onClick={handleProfessionalInformationClick}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faInfoCircle} />
          </ListItemIcon>
          <ListItemText primary="Professional info" />
        </ListItem>
        <ListItem button onClick={handleSecurityClick}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faShieldBlank} />
          </ListItemIcon>
          <ListItemText primary="Security" />
        </ListItem>
      </List>

      <div className={[styles['menu-footer'], styles['menu-list']].join(' ')}>
        <Divider />
        <ListItem>
          <ListItemIcon>
            <Avatar src={userGroup?.logoURL}>
              <FontAwesomeIcon icon={faUser} />
            </Avatar>
          </ListItemIcon>
          <ListItemText primary={userGroup.name} secondary={userGroupType} />
        </ListItem>
        <Divider />
        <div className="p-10">
          <BluePillButton
            fullWidth
            variant="outlined"
            onClick={() => {
              dispatch(logOut()).then(() => history.push('/login'));
            }}
          >
            SIGN OUT
          </BluePillButton>
        </div>
      </div>
    </Drawer>
  );
}
